import gql from 'graphql-tag';

export const suggestedWebpageSuggestedDokkioTagFragment = gql`
  fragment suggestedWebpageSuggestedDokkioTagFragment on SuggestedWebpageSuggestedDokkioTag {
    dokkioClass
    accountID
    webpageID
    suggestedDokkioTagID
  }
`;
export default suggestedWebpageSuggestedDokkioTagFragment;
